import * as React from 'react';
import { Drawer, Space } from 'antd';
import { NiButton, NiSpin } from '@component/index';
import { localizedString } from '@locale/index';
import { ReviewComp } from './review-comp';
import { DiffNodeConfig } from './node-config';
import '@style/component/diff-drawer.less';

export interface ReviewDrawerProps {
  titleExtra?: React.ReactNode;
  basePath: string[];
  rootNode?: DiffNodeConfig;
  data: any;
  visible: boolean;
  conflicting?: boolean;
  footerElements?: React.ReactNode[];
  loading?: boolean;
  onApprove?: () => void;
  disableApproval: boolean;
  onMerge?: () => void;
  resolveAgentId?: string;
  onResolve?: (data: any) => void;
  onClosePr?: () => void;
  onClose?: () => void;
}

export interface ReviewDrawerState {
  resolvedData?: any;
}

export class ReviewDrawer extends React.Component<
  ReviewDrawerProps,
  ReviewDrawerState
> {

  state = { resolvedData: undefined };

  render() {
    const {
      onClose,
      visible,
      data,
      rootNode,
      basePath,
      conflicting,
      footerElements,
      onResolve,
      onApprove,
      disableApproval,
      onMerge,
      onClosePr,
      loading = false,
      titleExtra
    } = this.props;

    const { resolvedData } = this.state;

    return (
      <Drawer
        className="diff-drawer"
        title={<div className="diff-drawer-title">
          <span>{localizedString(conflicting ? 'common_rebase_conflicts' : 'common_diff_info')}</span>
          <span>{titleExtra}</span>
        </div>}
        placement="right"
        closable={false}
        width={'60vw'}
        onClose={onClose}
        visible={visible}
        footer={
          <div className="diff-drawer-footer">
            {!conflicting && onClosePr &&
              <NiButton
                disabled={loading}
                style={{ marginRight: 16 }}
                type="default"
                onClick={() => {
                  onClosePr();
                }}
              >
                {localizedString('diff_info_close_pr')}
              </NiButton>
            }
            {!conflicting && onApprove &&
              <NiButton
                disabled={loading || disableApproval}
                type="primary"
                onClick={() => {
                  onApprove();
                }}
              >
                {localizedString('diff_info_approve')}
              </NiButton>
            }
            {!conflicting && onMerge &&
              <NiButton
                disabled={loading}
                type="primary"
                onClick={() => {
                  onMerge();
                }}
              >
                {localizedString('diff_info_merge')}
              </NiButton>
            }
            {conflicting && onResolve &&
              <NiButton
                disabled={loading}
                type="primary"
                onClick={() => {
                  if (onClose) {
                    onClose();
                  }
                  onResolve(resolvedData);
                }}
              >
                Resolve Conflicts
              </NiButton>
            }
            {
              footerElements && <Space>
                {footerElements}
              </Space>
            }
          </div>
        }
      >
        <div className="drawer-body">
          <NiSpin spinning={loading}>
            <ReviewComp
              basePath={basePath}
              rootNode={rootNode}
              conflicting={conflicting}
              data={data}
              resolveAgentId={this.props.resolveAgentId}
              onResolve={(nextData: any) => {

                this.setState({
                  resolvedData: nextData
                });
              }}
            />
          </NiSpin>
        </div>
      </Drawer >
    );
  }
}
